import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { LegantoEntity } from '../../rl-common/shared/shared/types/leganto-entity';
import { NgTagsService } from '../core/ng-tags.service';
import { NgUserService } from '../../core/ng-user.service';
import { TranslateService } from '@ngx-translate/core';
import { TagDisplay } from '../tag/tag-display';
import { EventPoolService } from '../../core/event-pool.service';
import { TagsChangesEvent } from '../../core/classes/tags-changes-event';
import { Subscription } from 'rxjs';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { Tag } from '../../store/model/tag.model';

@Component({
  selector: 'rl-tags-container',
  templateUrl: './tags-container.component.html',
  styleUrls: ['./tags-container.component.scss', './tags-container.component-rtl.css']
})
export class TagsContainerComponent implements OnInit, OnDestroy {

  @Input() set tags(tags: Tag[]) {
    this._tags = tags ? tags : [];
    this.setTagsToAdd();
  };
  @Input() legantoEntity: LegantoEntity;
  @Input() editDisabled: boolean;
  @Input() saveDisabled: boolean;
  @Input() freeTextEnabled: boolean;
  @Output() onRemove: EventEmitter<Tag> = new EventEmitter<Tag>();
  @Output() onAdd: EventEmitter<Tag> = new EventEmitter<Tag>();
  @Output() tagsChange : EventEmitter<Tag[]> = new EventEmitter<Tag[]>();

  _tags: Tag[] = [];

  constructor(private tagsService: NgTagsService, private userService: NgUserService, private translate: TranslateService, private eventPoolService: EventPoolService, private utilsService: UtilsService) {
  }

  tagsToAdd: TagDisplay[] = [];
  tagsChangesSub: Subscription;

  ngOnInit(): void {

    this.loadTagsToAdd();
    this.subscribeToTagsChanges();
  }

  subscribeToTagsChanges() {
    if (this.legantoEntity.entityType == EntityType.CITATION || this.legantoEntity.entityType == EntityType.COLLECTION) {
      this.tagsChangesSub = this.eventPoolService.tagsListener$.subscribe((e: TagsChangesEvent) => {
        if (e.tag.tagTypeFromEntity == 'PRIVATE' && e.type == 'ADD') {
          this.tagsService.addTagToOptions(e.tag);
          this.loadTagsToAdd();
        }
      });
    }
  }

  loadTagsToAdd() {
    this.tagsToAdd = this.tagsService.getTags(this.legantoEntity.entityType);
    this.setTagsToAdd();
  }

  setTagsToAdd() {
    this._tags.forEach(tag => {
      this.tagsToAdd = this.tagsToAdd.filter(t => t.tagId != tag.tagId);
    });
  }

  remove(tag: Tag) {
    this.removeTag(tag);

    if (this.saveDisabled) return;

    this.tagsService.delete(this.legantoEntity.entityType, this.legantoEntity.id, tag.id).subscribe(results => {
      this.eventPoolService.update(new TagsChangesEvent('DELETE', tag, { listStatus: results.newListStatus, citationStatus: results.citationStatus }));
    });
  }

  select(tag: Tag) {
    if (this.saveDisabled) return this.createNewTag(tag);

    this.tagsService.create(this.legantoEntity.entityType, this.legantoEntity.id, tag).subscribe(results => {
      this.eventPoolService.update(new TagsChangesEvent('ADD', this.createNewTag(results.tag), { listStatus: results.newListStatus, citationStatus: results.citationStatus }));
    });
  }

  removeTag(tag: Tag) {
    this._tags = this._tags.filter(obj => obj.id != tag.id);
    this.loadTagsToAdd();
    this.onRemove.emit(tag);
    this.tagsChange.emit(this._tags);
  }

  createNewTag(tag: Tag): Tag {
    let newTag = new Tag(tag);
    newTag.canRemove = true;
    this._tags.push(newTag);

    this.setTagsToAdd();
    this.onAdd.emit(newTag);
    this.tagsChange.emit(this._tags);

    return newTag;
  }

  ngOnDestroy(): void {
    this.tagsChangesSub?.unsubscribe();
  }
}


